export const splitName = (name: string = '') => {
    let last_name: string
    const nameParts = name.trim().split(' ')
    const first_name = nameParts[0]
    last_name = ''
    if (nameParts.length > 1) {
        last_name = nameParts[1]
    }
    if (nameParts.length > 2) {
        last_name = nameParts.slice(1).join(' ')
    }
    return {
        first_name,
        last_name,
    }
}